// Comparator for entities ordered by `sortIndex`, with `createdAt` as a stable
// tiebreaker. See plan/02 §Why `sortIndex` and §Conflict edge cases — two
// devices can land on the same sortIndex, and we resolve by oldest-first.
export function bySortIndex<T extends { sortIndex: number; createdAt: string }>(
  a: T,
  b: T,
): number {
  if (a.sortIndex !== b.sortIndex) return a.sortIndex - b.sortIndex;
  if (a.createdAt < b.createdAt) return -1;
  if (a.createdAt > b.createdAt) return 1;
  return 0;
}
